import { render, staticRenderFns } from "./mobileHome.vue?vue&type=template&id=a0298588&scoped=true&"
import script from "./mobileHome.vue?vue&type=script&lang=js&"
export * from "./mobileHome.vue?vue&type=script&lang=js&"
import style0 from "./mobileHome.vue?vue&type=style&index=0&id=a0298588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0298588",
  null
  
)

export default component.exports